/**
 * 轮播图
 */

import {
    get,
    post,
    put,
    del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectSlideshowById = (Id) => {
    return get('/api/app/Slideshow?CurrentId=' + Id);
}

/**
 * 根据number查询
 * @param {*} Id
 * @returns
 */
export const SelectSlideshowByNumber = (number) => {
    return get('/api/app/Slideshow?number=' + number);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddSlideshow = (data) => {
    return post('/api/app/Slideshow', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifySlideshow = (data) => {
    return put('/api/app/Slideshow', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataSlideshowList = (data) => {
    return post('/api/app/Slideshow/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteSlideshow = (id) => {
    return del('/api/app/Slideshow/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
export const ExportInjuryUnit = (data) => {
    let defaluturl = `/api/app/Slideshow/exportExcelFile`;
    let fileName = "轮播图"
    return download(fileName, defaluturl, data);
}